<template>
  <section v-if="matricula">
    <section>
      <section-header :current="current" />
      <section class="form-section">
        <h5>1. Informações Pessoais</h5>
        <pessoas :current="current" :auto="auto" branch="filiacao1" @populateEndereco="enderecoData = $event" v-if="ready"/>
      </section>
      <section class="form-section">
        <h5>2. Endereço</h5>
        <endereco :current="current" :auto="auto" v-if="ready" :autoPopulate="enderecoData" branch="filiacao1"/>
      </section>
    </section>
    <label class="check-control">
      <input
        type="checkbox"
        class="check"
        value="1"
        v-model="matricula.semFiliacao2"
        @change="handleSemFiliacao2Change"
      >
      <span>Não desejo declarar segunda filiação</span>
    </label>
    <section v-if="!matricula.semFiliacao2">
      <section-header :current="current" />
      <section class="form-section">
        <h5>1. Informações Pessoais</h5>
        <pessoas :current="current" :auto="auto" branch="filiacao2" @populateEndereco="enderecoData = $event" v-if="ready"/>
      </section>
      <section class="form-section">
        <h5>2. Endereço</h5>
        <endereco :current="current" :auto="auto" v-if="ready" :autoPopulate="enderecoData" branch="filiacao2"/>
      </section>
    </section>
  </section>
</template>

<script>
import SectionHeader from '@/components/matriculas/4/template/SectionHeader.vue'
import Pessoas from '@/components/matriculas/4/form/Pessoas.vue'
import Endereco from '@/components/matriculas/4/form/Endereco.vue'
import matriculaService from '@/services/matricula.service.js'
import { unformatDate } from '@/services/utils.service.js'

export default {
  components: {
    SectionHeader, Pessoas, Endereco
  },
  props: {
    current: Object,
    auto: Boolean,
    action: String,
    step: Object
  },
  data () {
    return {
      ready: false,
      filiacao1: null,
      filiacao2: null,
      enderecoData: null,
      matricula: null
    }
  },
  mounted () {
    this.$store.dispatch('matricula/get').then(response => {
      this.matricula = response
      // if ( response.aluno.Basicos.idPessoa ) {
      //   this.ready = true
      // } else {
      //   this.get()
      // }
      if ( this.matricula.matricula.idMatricula ) {
        this.get()
      }

      if(this.matricula.idSituacao == 1) {
        this.disabledAll = true
      }

      this.aluno = response.Aluno
    })
  },
  methods: {
    handleSemFiliacao2Change () {
      if ( !this.matricula.semFiliacao2 ) return

      this.$store.dispatch('matricula/clear', 'filiacao2').then(response => {
        this.matricula.filiacao2 = response
        this.enderecoData = null
      })
    },
    get () {
      this.ready = true
      window.spinner.emit("open")
      matriculaService.getFiliacao(this.matricula.matricula.idMatricula)
      .then( response => {
        console.log("getFiliacao View", response.data)
        const pessoa = response.data.pessoa
        if (pessoa.mae) {
          this.matricula.filiacao2.Basicos = pessoa.mae.Basicos ?? null
          if (pessoa.mae.Endereco) {
            this.matricula.filiacao2.endereco = pessoa.mae.Endereco ?? null
            if (pessoa.mae.Endereco.nomeCidade) {
              this.matricula.filiacao2.endereco.cidade = pessoa.mae.Endereco.nomeCidade
            }
          }
          if (pessoa.mae.Responsavel && pessoa.mae.Responsavel.idMatricula) {
            this.matricula.filiacao2.responsavel = pessoa.mae.Responsavel
          }
          if (pessoa.mae.Documento) {
            this.matricula.filiacao2.documento = {
              idDocumento: pessoa.mae.Documento.idDocumento,
              idPessoa: pessoa.mae.Documento.idPessoa,
              cpf: pessoa.mae.Documento.cpf,
              rg: pessoa.mae.Documento.rg,
              rgEmissor: pessoa.mae.Documento.rgEmissor,
            }
          }
          if (this.matricula.filiacao2.Basicos?.dataNascimento) {
            this.matricula.filiacao2.Basicos.dataNascimento = unformatDate(this.matricula.filiacao2.Basicos.dataNascimento)
          }
        } else {
          this.matricula.semFiliacao2 = true
        }
        
        if (pessoa.pai) {
          this.matricula.filiacao1.Basicos = pessoa.pai.Basicos ?? null
          if (pessoa.pai.Endereco) {
            this.matricula.filiacao1.endereco = pessoa.pai.Endereco ?? null
            if (pessoa.pai.Endereco.nomeCidade) {
              this.matricula.filiacao1.endereco.cidade = pessoa.pai.Endereco.nomeCidade
            }
          }
          if (pessoa.pai.Responsavel && pessoa.pai.Responsavel.idMatricula) {
            this.matricula.filiacao1.responsavel = pessoa.pai.Responsavel
          }
          if (pessoa.pai.Documento) {
            this.matricula.filiacao1.documento = {
              idDocumento: pessoa.pai.Documento.idDocumento,
              idPessoa: pessoa.pai.Documento.idPessoa,
              cpf: pessoa.pai.Documento.cpf,
              rg: pessoa.pai.Documento.rg,
              rgEmissor: pessoa.pai.Documento.rgEmissor,
            }
          }
          
          if (this.matricula.filiacao1.Basicos?.dataNascimento) {
            this.matricula.filiacao1.Basicos.dataNascimento = unformatDate(this.matricula.filiacao1.Basicos.dataNascimento)
          }
        }
      })
      .catch( error => {
        console.error(error)
      })
      .finally(() => {
        window.spinner.emit("close")
      })
    }
  }
}
</script>

<style lang="scss" scoped>
h5 {
  margin-bottom: $hmg_mid;
}

.form-section {
  margin-bottom: $hmg_mid;
}
</style>
